import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, Button, TextField, InputAdornment, Switch, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Grid, Snackbar, Alert, Chip,
  Collapse
} from '@mui/material';
import { Add, Search, Edit, Delete, KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { countriesAPI, statesAPI, airportsAPI } from '../../services/api';
import { Flight } from '@mui/icons-material';

var BLANK = { name: '', iso2: '', dial_code: '', is_active: true, sort_order: 0 };

export default function CountrySettings() {
  var ls = useState([]); var list = ls[0]; var setList = ls[1];
  var qs = useState(''); var query = qs[0]; var setQuery = qs[1];
  var es = useState(null); var editing = es[0]; var setEditing = es[1];
  var ts = useState(''); var toast = ts[0]; var setToast = ts[1];
  var bs = useState(false); var busy = bs[0]; var setBusy = bs[1];

  // States nested under countries
  var xs = useState(null); var expandedCountry = xs[0]; var setExpandedCountry = xs[1];
  var sm = useState({}); var statesMap = sm[0]; var setStatesMap = sm[1];
  var se = useState(null); var editingState = se[0]; var setEditingState = se[1];
  var sb = useState(false); var stateBusy = sb[0]; var setStateBusy = sb[1];

  var STATE_BLANK = { name: '', state_code: '', country_iso2: '', is_active: true };

  // Airports nested under countries
  var am = useState({}); var airportsMap = am[0]; var setAirportsMap = am[1];
  var ae = useState(null); var editingAirport = ae[0]; var setEditingAirport = ae[1];
  var ab = useState(false); var airportBusy = ab[0]; var setAirportBusy = ab[1];

  var AIRPORT_BLANK = { name: '', iata_code: '', city: '', country_iso2: '', is_active: true };

  function loadStates(iso2) {
    if (!iso2) return;
    statesAPI.list(iso2).then(function(r) {
      var next = Object.assign({}, statesMap);
      next[iso2] = (r.data && r.data.data) || [];
      setStatesMap(next);
    }).catch(function() {});
  }

  function loadAirports(iso2) {
    if (!iso2) return;
    airportsAPI.list(iso2).then(function(r) {
      var next = Object.assign({}, airportsMap);
      next[iso2] = (r.data && r.data.data) || [];
      setAirportsMap(next);
    }).catch(function() {});
  }

  function toggleExpand(c) {
    if (expandedCountry === c.id) {
      setExpandedCountry(null);
    } else {
      setExpandedCountry(c.id);
      if (c.iso2) { loadStates(c.iso2); loadAirports(c.iso2); }
    }
  }

  function saveState() {
    var payload = {
      name: editingState.name,
      country_iso2: editingState.country_iso2,
      state_code: editingState.state_code || '',
      is_active: !!editingState.is_active,
    };
    setStateBusy(true);
    var req = editingState.id ? statesAPI.update(editingState.id, payload) : statesAPI.create(payload);
    req.then(function() {
      setToast(editingState.id ? 'State saved' : 'State added');
      setEditingState(null);
      loadStates(payload.country_iso2);
    }).catch(function(e) {
      setToast((e.response && e.response.data && e.response.data.error) || 'Could not save state');
    }).then(function() { setStateBusy(false); });
  }

  function toggleStateActive(s) {
    statesAPI.toggle(s.id).then(function() {
      setToast(s.is_active ? s.name + ' hidden' : s.name + ' shown');
      loadStates(s.country_iso2);
    }).catch(function() { setToast('Could not toggle state'); });
  }

  function removeState(s) {
    if (!window.confirm('Remove ' + s.name + '? Existing applications keep their answer.')) return;
    statesAPI.remove(s.id).then(function() {
      setToast(s.name + ' removed');
      loadStates(s.country_iso2);
    }).catch(function() { setToast('Could not remove state'); });
  }

  function saveAirport() {
    var payload = {
      name: editingAirport.name,
      iata_code: editingAirport.iata_code || '',
      city: editingAirport.city || '',
      country_iso2: editingAirport.country_iso2,
      is_active: !!editingAirport.is_active,
    };
    setAirportBusy(true);
    var req = editingAirport.id ? airportsAPI.update(editingAirport.id, payload) : airportsAPI.create(payload);
    req.then(function() {
      setToast(editingAirport.id ? 'Airport saved' : 'Airport added');
      setEditingAirport(null);
      loadAirports(payload.country_iso2);
    }).catch(function(e) {
      setToast((e.response && e.response.data && e.response.data.error) || 'Could not save airport');
    }).then(function() { setAirportBusy(false); });
  }

  function toggleAirportActive(a) {
    airportsAPI.toggle(a.id).then(function() {
      setToast(a.is_active ? a.name + ' hidden' : a.name + ' shown');
      loadAirports(a.country_iso2);
    }).catch(function() { setToast('Could not toggle airport'); });
  }

  function removeAirport(a) {
    if (!window.confirm('Remove ' + a.name + ' (' + a.iata_code + ')? Existing applications keep their answer.')) return;
    airportsAPI.remove(a.id).then(function() {
      setToast(a.name + ' removed');
      loadAirports(a.country_iso2);
    }).catch(function() { setToast('Could not remove airport'); });
  }

  function load() {
    countriesAPI.list().then(function(r) { setList(r.data.data || []); });
  }
  useEffect(load, []);

  function save() {
    var payload = {
      name: editing.name,
      iso2: editing.iso2,
      dial_code: editing.dial_code,
      is_active: !!editing.is_active,
      sort_order: parseInt(editing.sort_order, 10) || 0,
    };
    setBusy(true);
    var req = editing.id ? countriesAPI.update(editing.id, payload) : countriesAPI.create(payload);
    req.then(function() {
      setToast(editing.id ? 'Country saved' : 'Country added');
      setEditing(null); load();
    }).catch(function(e) {
      setToast((e.response && e.response.data && e.response.data.error) || 'Could not save');
    }).then(function() { setBusy(false); });
  }

  function toggleActive(c) {
    countriesAPI.update(c.id, {
      name: c.name, iso2: c.iso2, dial_code: c.dial_code,
      is_active: !c.is_active, sort_order: c.sort_order,
    }).then(function() {
      setToast(c.is_active ? c.name + ' hidden from forms' : c.name + ' shown on forms');
      load();
    }).catch(function() { setToast('Could not update'); });
  }

  function remove(c) {
    if (!window.confirm('Remove ' + c.name + ' from the list? Applications that already recorded it keep their answer. Hiding it instead is usually safer.')) return;
    countriesAPI.remove(c.id).then(function() { setToast(c.name + ' removed'); load(); })
      .catch(function() { setToast('Could not remove'); });
  }

  var filtered = list.filter(function(c) {
    if (!query) return true;
    var hay = (c.name + ' ' + (c.iso2 || '') + ' ' + (c.dial_code || '')).toLowerCase();
    return hay.indexOf(query.toLowerCase()) >= 0;
  });
  var activeCount = list.filter(function(c) { return c.is_active; }).length;

  var E = React.createElement;

  return E(Box, null,
    E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:1, mb:1}},
      E(Typography, {variant:'h4'}, 'Countries'),
      E(Button, {variant:'contained', startIcon:E(Add),
        onClick:function(){ setEditing(Object.assign({}, BLANK)); }}, 'Add country')),
    E(Typography, {variant:'body2', color:'text.secondary', sx:{mb:3}},
      'This list fills the Country field and the dialling-code picker on phone fields, across every form. Expand a country to manage its states/provinces and airports. ' +
      activeCount + ' of ' + list.length + ' entries are shown to applicants.'),

    E(TextField, {size:'small', placeholder:'Search name, ISO code or dialling code', value:query,
      onChange:function(e){ setQuery(e.target.value); }, sx:{mb:2, width:'100%', maxWidth:420},
      InputProps:{startAdornment:E(InputAdornment, {position:'start'}, E(Search, {fontSize:'small'}))}}),

    E(Card, null,
      E(TableContainer, null,
        E(Table, {size:'small'},
          E(TableHead, null,
            E(TableRow, null,
              E(TableCell, {sx:{width:40}}),
              E(TableCell, null, 'Name'),
              E(TableCell, null, 'ISO'),
              E(TableCell, null, 'Dialling code'),
              E(TableCell, null, 'Order'),
              E(TableCell, null, 'Shown on forms'),
              E(TableCell, {align:'right'}, 'Actions'))),
          E(TableBody, null,
            filtered.map(function(c) {
              var isExpanded = expandedCountry === c.id;
              var countryStates = (c.iso2 && statesMap[c.iso2]) || [];
              var countryAirports = (c.iso2 && airportsMap[c.iso2]) || [];
              return E(React.Fragment, {key:c.id},
                E(TableRow, {hover:true, sx:{cursor:'pointer', '& > td':{borderBottom: isExpanded ? 'none' : undefined}},
                  onClick:function(){ if (c.iso2) toggleExpand(c); }},
                  E(TableCell, {sx:{width:40, px:1}},
                    c.iso2 ? E(IconButton, {size:'small'},
                      isExpanded ? E(KeyboardArrowDown, {fontSize:'small'}) : E(KeyboardArrowRight, {fontSize:'small'})) : null),
                  E(TableCell, null, c.name),
                  E(TableCell, null, c.iso2 ? E(Chip, {label:c.iso2, size:'small', variant:'outlined'}) : '\u2014'),
                  E(TableCell, null, c.dial_code || '\u2014'),
                  E(TableCell, null, c.sort_order || 0),
                  E(TableCell, null,
                    E(Switch, {size:'small', checked:!!c.is_active,
                      onClick:function(e){ e.stopPropagation(); },
                      onChange:function(){ toggleActive(c); }})),
                  E(TableCell, {align:'right'},
                    E(IconButton, {size:'small', onClick:function(e){ e.stopPropagation(); setEditing(Object.assign({}, c)); }},
                      E(Edit, {fontSize:'small'})),
                    E(IconButton, {size:'small', color:'error', onClick:function(e){ e.stopPropagation(); remove(c); }},
                      E(Delete, {fontSize:'small'})))),
                E(TableRow, null,
                  E(TableCell, {colSpan:8, sx:{py:0, px:0, borderBottom: isExpanded ? undefined : 'none'}},
                    E(Collapse, {in:isExpanded, timeout:'auto', unmountOnExit:true},
                      E(Box, {sx:{py:1.5, px:3, bgcolor:'action.hover'}},
                        E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center', mb:1}},
                          E(Typography, {variant:'subtitle2', color:'text.secondary'},
                            'States / Provinces in ' + c.name + ' (' + countryStates.length + ')'),
                          E(Button, {size:'small', startIcon:E(Add), onClick:function(){
                            setEditingState(Object.assign({}, STATE_BLANK, {country_iso2: c.iso2}));
                          }}, 'Add state')),
                        countryStates.length > 0
                          ? E(Table, {size:'small'},
                              E(TableHead, null,
                                E(TableRow, null,
                                  E(TableCell, null, 'Name'),
                                  E(TableCell, null, 'Code'),
                                  E(TableCell, null, 'Active'),
                                  E(TableCell, {align:'right'}, 'Actions'))),
                              E(TableBody, null,
                                countryStates.map(function(s) {
                                  return E(TableRow, {key:s.id, hover:true},
                                    E(TableCell, null, s.name),
                                    E(TableCell, null, s.state_code || '\u2014'),
                                    E(TableCell, null,
                                      E(Switch, {size:'small', checked:!!s.is_active,
                                        onChange:function(){ toggleStateActive(s); }})),
                                    E(TableCell, {align:'right'},
                                      E(IconButton, {size:'small', onClick:function(){
                                        setEditingState(Object.assign({}, s));
                                      }}, E(Edit, {fontSize:'small'})),
                                      E(IconButton, {size:'small', color:'error', onClick:function(){
                                        removeState(s);
                                      }}, E(Delete, {fontSize:'small'}))));
                                })))
                          : E(Typography, {variant:'body2', color:'text.secondary', sx:{py:1}},
                              c.iso2 ? 'No states recorded for this country yet.' : 'Set an ISO code to manage states.'),
                        E(Box, {sx:{mt:2}}),
                        E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center', mb:1}},
                          E(Typography, {variant:'subtitle2', color:'text.secondary'},
                            E(Flight, {fontSize:'small', sx:{mr:0.5, verticalAlign:'middle'}}),
                            'Airports in ' + c.name + ' (' + countryAirports.length + ')'),
                          E(Button, {size:'small', startIcon:E(Add), onClick:function(){
                            setEditingAirport(Object.assign({}, AIRPORT_BLANK, {country_iso2: c.iso2}));
                          }}, 'Add airport')),
                        countryAirports.length > 0
                          ? E(Table, {size:'small'},
                              E(TableHead, null,
                                E(TableRow, null,
                                  E(TableCell, null, 'Name'),
                                  E(TableCell, null, 'IATA'),
                                  E(TableCell, null, 'City'),
                                  E(TableCell, null, 'Active'),
                                  E(TableCell, {align:'right'}, 'Actions'))),
                              E(TableBody, null,
                                countryAirports.map(function(a) {
                                  return E(TableRow, {key:a.id, hover:true},
                                    E(TableCell, null, a.name),
                                    E(TableCell, null, E(Chip, {label:a.iata_code, size:'small', variant:'outlined'})),
                                    E(TableCell, null, a.city || '—'),
                                    E(TableCell, null,
                                      E(Switch, {size:'small', checked:!!a.is_active,
                                        onChange:function(){ toggleAirportActive(a); }})),
                                    E(TableCell, {align:'right'},
                                      E(IconButton, {size:'small', onClick:function(){
                                        setEditingAirport(Object.assign({}, a));
                                      }}, E(Edit, {fontSize:'small'})),
                                      E(IconButton, {size:'small', color:'error', onClick:function(){
                                        removeAirport(a);
                                      }}, E(Delete, {fontSize:'small'}))));
                                })))
                          : E(Typography, {variant:'body2', color:'text.secondary', sx:{py:1}},
                              'No airports recorded for this country yet.'))))));
            }),
            filtered.length === 0 ? E(TableRow, null,
              E(TableCell, {colSpan:8, align:'center', sx:{py:4, color:'text.secondary'}},
                'Nothing matches that search.')) : null)))),

    editing ? E(Dialog, {open:true, onClose:function(){ setEditing(null); }, maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, editing.id ? 'Edit country' : 'Add country'),
      E(DialogContent, {sx:{pt:'16px !important'}},
        E(Grid, {container:true, spacing:2},
          E(Grid, {item:true, xs:12},
            E(TextField, {fullWidth:true, label:'Name', value:editing.name, autoFocus:true,
              helperText:'Exactly as it should appear in the dropdown',
              onChange:function(e){ setEditing(Object.assign({}, editing, {name:e.target.value})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, label:'ISO code', value:editing.iso2 || '', placeholder:'HK',
              inputProps:{maxLength:2},
              onChange:function(e){ setEditing(Object.assign({}, editing, {iso2:e.target.value.toUpperCase()})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, label:'Dialling code', value:editing.dial_code || '', placeholder:'+852',
              onChange:function(e){ setEditing(Object.assign({}, editing, {dial_code:e.target.value})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, type:'number', label:'Sort order', value:editing.sort_order || 0,
              helperText:'0 sorts alphabetically; use a negative number to pin to the top',
              onChange:function(e){ setEditing(Object.assign({}, editing, {sort_order:e.target.value})); }})),
          E(Grid, {item:true, xs:6, sx:{display:'flex', alignItems:'center'}},
            E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
              E(Switch, {checked:!!editing.is_active,
                onChange:function(e){ setEditing(Object.assign({}, editing, {is_active:e.target.checked})); }}),
              E(Typography, {variant:'body2'}, 'Shown on forms'))))),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setEditing(null); }}, 'Cancel'),
        E(Button, {variant:'contained', onClick:save, disabled:busy || !editing.name.trim()},
          editing.id ? 'Save changes' : 'Add country'))) : null,

    editingState ? E(Dialog, {open:true, onClose:function(){ setEditingState(null); }, maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, editingState.id ? 'Edit state' : 'Add state'),
      E(DialogContent, {sx:{pt:'16px !important'}},
        E(Grid, {container:true, spacing:2},
          E(Grid, {item:true, xs:12},
            E(TextField, {fullWidth:true, label:'State / Province name', value:editingState.name, autoFocus:true,
              onChange:function(e){ setEditingState(Object.assign({}, editingState, {name:e.target.value})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, label:'State code', value:editingState.state_code || '', placeholder:'KA',
              helperText:'ISO 3166-2 subdivision code (optional)',
              onChange:function(e){ setEditingState(Object.assign({}, editingState, {state_code:e.target.value.toUpperCase()})); }})),
          E(Grid, {item:true, xs:6, sx:{display:'flex', alignItems:'center'}},
            E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
              E(Switch, {checked:!!editingState.is_active,
                onChange:function(e){ setEditingState(Object.assign({}, editingState, {is_active:e.target.checked})); }}),
              E(Typography, {variant:'body2'}, 'Active'))))),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setEditingState(null); }}, 'Cancel'),
        E(Button, {variant:'contained', onClick:saveState, disabled:stateBusy || !editingState.name.trim()},
          editingState.id ? 'Save changes' : 'Add state'))) : null,

    editingAirport ? E(Dialog, {open:true, onClose:function(){ setEditingAirport(null); }, maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, editingAirport.id ? 'Edit airport' : 'Add airport'),
      E(DialogContent, {sx:{pt:'16px !important'}},
        E(Grid, {container:true, spacing:2},
          E(Grid, {item:true, xs:12},
            E(TextField, {fullWidth:true, label:'Airport name', value:editingAirport.name, autoFocus:true,
              onChange:function(e){ setEditingAirport(Object.assign({}, editingAirport, {name:e.target.value})); }})),
          E(Grid, {item:true, xs:4},
            E(TextField, {fullWidth:true, label:'IATA code', value:editingAirport.iata_code || '', placeholder:'HYD',
              inputProps:{maxLength:3},
              onChange:function(e){ setEditingAirport(Object.assign({}, editingAirport, {iata_code:e.target.value.toUpperCase()})); }})),
          E(Grid, {item:true, xs:8},
            E(TextField, {fullWidth:true, label:'City', value:editingAirport.city || '', placeholder:'Hyderabad',
              onChange:function(e){ setEditingAirport(Object.assign({}, editingAirport, {city:e.target.value})); }})),
          E(Grid, {item:true, xs:6, sx:{display:'flex', alignItems:'center'}},
            E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
              E(Switch, {checked:!!editingAirport.is_active,
                onChange:function(e){ setEditingAirport(Object.assign({}, editingAirport, {is_active:e.target.checked})); }}),
              E(Typography, {variant:'body2'}, 'Active'))))),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setEditingAirport(null); }}, 'Cancel'),
        E(Button, {variant:'contained', onClick:saveAirport,
          disabled:airportBusy || !editingAirport.name.trim() || !editingAirport.iata_code.trim()},
          editingAirport.id ? 'Save changes' : 'Add airport'))) : null,

    E(Snackbar, {open:!!toast, autoHideDuration:3000, onClose:function(){ setToast(''); }},
      E(Alert, {severity:'info', onClose:function(){ setToast(''); }}, toast)));
}
